import { render } from "./MediaflowSendToLiveButton.vue?vue&type=template&id=0da60116"
import script from "./MediaflowSendToLiveButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowSendToLiveButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Mediaflow/MediaflowSendToLiveButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0da60116"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0da60116', __exports__)) {
    api.reload('0da60116', __exports__)
  }
  
  module.hot.accept("./MediaflowSendToLiveButton.vue?vue&type=template&id=0da60116", () => {
    api.rerender('0da60116', render)
  })

}


export default __exports__